package com.vizio.redwolf.auth.api

import com.vizio.redwolf.utils.ResponseHeaders
import kotlin.js.JsExport

@JsExport
class HasPinResult(val headers: ResponseHeaders, val response: HasPinResponse)

@JsExport
class CreatePinResult(val headers: ResponseHeaders, val response: CreatePinResponse)

@JsExport
class ValidatePinResult(val headers: ResponseHeaders, val response: ValidatePinResponse)

@JsExport
class UpdatePinResult(val headers: ResponseHeaders, val response: UpdatePinResponse)

@JsExport
class DeletePinResult(val headers: ResponseHeaders, val response: DeletePinResponse)

@JsExport
sealed class VersionResult<ResponseHeaders, out T : Any> {
    data class Success<ResponseHeaders, out T : Any>(val headers: ResponseHeaders, val data: T) : VersionResult<ResponseHeaders, T>()
    data class Failed(val headers: ResponseHeaders, val message: String) : VersionResult<ResponseHeaders, Nothing>()
    data class Error(val headers: ResponseHeaders, val exception: Throwable) : VersionResult<ResponseHeaders, Nothing>()
    data class Timeout(val headers: ResponseHeaders, val exception: Throwable) : VersionResult<ResponseHeaders, Nothing>()

    fun <R> fold (
        onSuccess: (Success: Success<ResponseHeaders, T>) -> R,
        onFailed: (Failed: Failed) -> R,
        onError: (Error: Error) -> R,
        onTimeout: (Timeout: Timeout) -> R
    ) : R {
        return when (this) {
            is Success -> onSuccess(Success(this.headers, this.data))
            is Failed -> onFailed(Failed(this.headers, this.message))
            is Error -> onError(Error(this.headers, this.exception))
            is Timeout -> onTimeout(Timeout(this.headers, this.exception))
        }
    }
}